<template>
  <div>
    <TrackCodes :progressCode="[120, 130, 140, 150, 170]" :isPaid="true"></TrackCodes>
  </div>
</template>
<script>
import TrackCodes from '@/components/TrackCodesComponent.vue'

export default {
  name: 'MeasuringOut',
  components: {
    TrackCodes
  },
  data () {
    return {
      componentType: 'history'
    }
  }
}
</script>

<style>
</style>
